import type { PageOverlayFragment } from "../client/generated";
import type { EditorAction, EditorState } from "./reducers";
import { RegionsToolOverlay } from "../regions/RegionsToolOverlay";
import { TableEditorOverlay } from "../tables/TableEditorOverlay";

type Props = {
  fragment: PageOverlayFragment;
  state: EditorState;
  dispatch: React.Dispatch<EditorAction>;
};

export function PageOverlay({ fragment, state, dispatch }: Props) {
  if (state.table) {
    return <TableEditorOverlay tableState={state.table} dispatch={dispatch} />;
  }

  return (
    <RegionsToolOverlay fragment={fragment} state={state} dispatch={dispatch} />
  );
}
